<template>
    <div class="lucky-page">
        <div id="subscribePopup">
            <h2>Allow Notifications</h2>
            <p>Would you like to subscribe to push notifications?</p>
            <button id="acceptBtn" class="popup-button">Allow</button>
            <button id="rejectBtn" class="popup-button">Don't Allow</button>
       </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getFirebaseToken, onForegroundMessage } from './../firebase';
export default {
    data() {
        return {
            rotate: '',
            activeindex: null,
            number: 0,
            jishu: 0,
            id: '',
            price: 0,
            infoShow: false,
            infoText: '',
            commaShow: false,
            imgUrl: '',
            tagShow: 1,
            shoplist: [],


            hongbaolist: [],
            remain: 0,
            showLoginModal: false, // 是否登录
            isLogin: false,
            showFinalModal: false,  // 抽奖弹框
            showLogModal: false, // 抽奖记录弹框
            onLink: '',
            info: '',
            amount: 0, // 旋转结果
            isWin: false,
            xylp_logo: '',
            xylp_background: '',
            url: null
        };
    },
    computed: {
        ...mapGetters(['loading']),
        boxHeightRem() {
            return this.innerHeightRem;
        },
    },
    beforeCreate() {

    },
    mounted() {
        this.$nextTick(() => {
            onForegroundMessage()
                .then((payload) => {
                    const { notification: { title, body, icon } } = payload;
                    let notification = new Notification(title, {
                        icon: icon,
                        body: body
                    });
                    notification.onclick = function () {
                        //可直接打开通知notification相关联的tab窗口
                        window.focus();
                        notification.close();
                    }
                })
                // eslint-disable-next-line no-console
                .catch(err => console.log('An error occured while retrieving foreground message. ', err));
            this.notify()
        })
        // 获取url
        const urlParams = new URLSearchParams(window.location.search);
        const url = urlParams.get('url');
        if (url) {
            var iframe = document.createElement("iframe");
            iframe.name = "myIframe";
            iframe.src = url
            iframe.style = 'width:100%;height:100vh;border:0;'
            // 将iframe元素添加到文档中
            document.getElementsByClassName('lucky-page')[0].appendChild(iframe);
        }
        document.getElementById('acceptBtn').onclick = () => {
            this.notify()
            document.getElementById('subscribePopup').style.display = 'none'
        }
        document.getElementById('rejectBtn').onclick = () => {
            document.getElementById('subscribePopup').style.display = 'none'
        }
    },
    methods: {
      detectDevice() {
        const userAgent = navigator.userAgent;
        let deviceType = 'pc';

        if (/android/i.test(userAgent)) {
          deviceType = 'android';
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          deviceType = 'ios';
        }
        return deviceType;
      }, 
        openNotification() {
            document.getElementById('subscribePopup').style.display = 'block'
        },
        notify() {
            var u = navigator.userAgent;
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if(!isIOS) return
            // 先检查浏览器是否支持
            if (!("Notification" in window)) {
                alert("This browser does not support desktop notification");
            }
            // 检查用户是否同意接受通知
            else if (Notification.permission === "granted") {
                // If it's okay let's create a notification
                this.handleGetFirebaseToken()
            }
            // 否则我们需要向用户获取权限
            else if (Notification.permission !== "denied" || Notification.permission === 'denied') {
                Notification.requestPermission().then(permission => {
                    // 如果用户接受权限，我们就可以发起一条消息
                    if (permission === "granted") {
                        this.handleGetFirebaseToken()
                    } else if (permission === 'denied') {
                        this.openNotification()
                    } else if (permission === 'default') {
                        this.openNotification()
                    }
                });
            }
        },
        handleGetFirebaseToken() {
            getFirebaseToken()
                .then((firebaseToken) => {
                    if (firebaseToken) {
                        this.fmsToken(firebaseToken)
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
        },
        async fmsToken(token) {
            this.$store.dispatch('SET_LOADING', true)
            const urlParams = new URLSearchParams(window.location.search);
            const codeTemp = urlParams.get('code');
            await this.$axios.post("https://t11-php-test3.zkkwrhu.com/api/AppPwa/setFcmToken", {
                code: codeTemp,
                token: token,
                device_type: this.detectDevice()
            })
            this.$store.dispatch('SET_LOADING', false)
        },
        customAlert(content, title, width, top) {
            if (content == undefined) {
                content = "";
            }
            if (title == undefined) {
                title = "温馨提示";
            }
            if (width == undefined) {
                width = "360px";
            }
            if (top == undefined) {
                top = "50%";
            }
            this.$modal.confirm({
                title: title,
                content: content,
                okText: '确定',
                cancelText: '取消'
            });
        },
        closeModal(visible) {
            if (visible === 'showLoginModal') {
                let _info = sessionStorage.getItem('info')
                if (_info) {
                    this.isLogin = true
                    this.info = JSON.parse(_info)
                    this.remain = this.info.total_draw_times
                }
            }
            this[visible] = false
        },
        logFun() {
            if (!this.isLogin) {
                this.showLoginModal = true
            } else this.showLogModal = true
        },
        errorFun(msg) {
            this.$message.error(msg)
        },
    },

    watch: {
    }
};
</script>

<style lang="less" scoped>
* {
    list-style: none;
    -moz-user-select: none;
    /*火狐*/
    -webkit-user-select: none;
    /*webkit浏览器*/
    -ms-user-select: none;
    /*IE10*/
    -khtml-user-select: none;
    /*早期浏览器*/
    user-select: none;
}

p {
    margin: 0;
    padding: 0;
}

a {
    color: #fff;
}

iframe::-webkit-scrollbar {
    width: 0;
    display: none;
}



.lucky-page {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100% auto;

    .my-body {}

    .bottom-box {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: .44rem;
        line-height: .44rem;
        flex-shrink: 0;
        border-top: 1px solid #FF8D8C;
        background: rgba(191, 0, 26, 0.90);
        display: flex;
        justify-content: space-between;
        align-content: center;

        >div {
            width: 40%;
            text-align: center;
            color: #FFF;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
        }

        span {
            color: #FFF;
        }
    }

    p {
        margin: 0;
        padding: 0;
    }

    .heightBG {
        .top-back {
            height: 1.5rem;
            text-align: center;
            line-height: 0;

            img {
                display: inline-block;
                width: 1rem;
                height: auto;
                vertical-align: text-top;
                object-fit: contain;
            }
        }
    }

    .hegithBottom {
        width: 100%;
        padding-top: 0.4rem;
        padding-bottom: 1em;
        background-size: 100% 100%;

        .remain-count {
            margin: 0.1rem auto 0 auto;
            text-align: center;
            font-family: MicrosoftYaHei;


            border-radius: 20px;
            border: 1px solid rgba(255, 255, 255, 0.80);
            background: rgba(191, 0, 26, 0.60);
            min-width: .96rem;
            max-width: max-content;
            padding: 0 .1rem;
            height: .32rem;
            line-height: .32rem;

            color: #FFF;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 15px;
            font-style: normal;
            font-weight: 500;


        }

        .click-toLink {
            width: 76%;
            height: 0.82rem;
            padding: 0 0.3rem;
            margin: 0 auto;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            // background: url(../assets/img/bigWheel/m_click_bottom.png) no-repeat;
            background-size: 100% 100%;

            div {
                height: 0.4rem;
                margin: auto 0;
            }

            .win-record {
                // background: url(../assets/img/bigWheel/m_win_record.png) no-repeat;
                background-size: 100% 100%;
            }

            .buy-point {
                // background: url(../assets/img/bigWheel/m_buy_point.png) no-repeat;
                background-size: 100% 100%;
            }

            .show-rules {
                // background: url(../assets/img/bigWheel/m_rules.png) no-repeat;
                background-size: 100% 100%;
            }
        }
    }

    .roulette {
        position: relative;
        background: url(../assets/img/bigWheel/zp.png) no-repeat center center;
        width: 3.65rem;
        height: 3.65rem;
        margin: 0 auto;
        max-width: 3.65rem;
        max-height: 3.65rem;
        background-size: contain;
        padding: .4rem;

        .point {
            margin: auto;
            width: 0.7rem;
            height: 1rem;
            position: absolute;
            left: 0.03rem;
            right: 0;
            top: 0;
            bottom: 0.3rem;
            background: url('./../assets/img/bigWheel/point.png') no-repeat bottom;
            cursor: pointer;
            background-size: contain;
        }

        .circleBox {
            width: 100%;
            height: 100%;
            overflow: hidden;
            cursor: pointer;
            position: relative;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            border-top-left-radius: 9.99rem;
            border-top-right-radius: 9.99rem;
            border-bottom-right-radius: 9.99rem;
            border-bottom-left-radius: 9.99rem;
            border-radius: 10rem;

            .prizeCircle {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                border-top-left-radius: 9.99rem;
                border-top-right-radius: 9.99rem;
                border-bottom-right-radius: 9.99rem;
                border-bottom-left-radius: 9.99rem;
                border-radius: 10rem;
                width: 100%;
                height: 100%;
                -webkit-transition: 2.7s;
                transition: 2.7s;
                overflow: hidden;

                .fanBox {
                    .fan {
                        margin: 0;
                        width: 50%;
                        height: 50%;
                        position: absolute;
                        -webkit-transform-origin: 100% 100%;
                        transform-origin: 100% 100%;
                        color: #fff;
                        font-size: 0.5rem;
                    }

                    .fanOdd {
                        background: linear-gradient(202deg, #FFDA86 16.89%, #FCA965 49.18%);
                    }

                    .fanEven {
                        background: #FEF4D9;
                    }

                    .prizeTxtOdd {
                        color: #fff;
                    }

                    .prizeTxtEven {
                        color: #F87201;
                    }

                    .prizeTxt {
                        font-family: Reklame Script;
                        font-size: 24px;
                        font-weight: 500;

                        position: absolute;
                        width: 30%;
                        height: 95%;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        top: 0;
                        margin: auto;
                        text-align: center;
                    }
                }

                .winner-bg {
                    >div:first-child {
                        background: linear-gradient(180deg, #EE3945 0%, #FB8B71 100%);
                    }

                    .prizeTxt {
                        color: #fff;
                    }
                }

                .fanBox18888,
                .fanBox1888 {
                    span {
                        display: inline-block;
                        transform: rotate(270deg);
                        padding-right: 19px;
                    }
                }

                .fanBoxEven:first-child {
                    >div:first-child {
                        background: #fff;
                    }

                    .prizeTxt {
                        color: #F87201;
                    }
                }
            }
        }
    }

}
</style>
